// console.log('--> bundle_product.js <--');

window.bundle_product = {
  init:function(){
    bundle_product.attachEvents();

    if(window.outerWidth <= 1024){
      setTimeout(function(){
        window.setGridHeight('.custom-bundle-product-main_left .item .quantity_price-box_title h3');
        window.onresize = (function(){
          window.setGridHeight('.custom-bundle-product-main_left .item .quantity_price-box_title h3');
        });
      },1000)
    }
  },
  attachEvents:function(){
    document.querySelectorAll('[bundle-quantity-selector]').forEach(event => bundle_product.changeQty(event))
    document.querySelectorAll('.is-added [data-item-remobe-button]').forEach(event => bundle_product.removeItemFromBundle(event));
    document.querySelectorAll('[data-open-product-popup]').forEach(event => bundle_product.quickView(event));
    document.querySelector('[overlay-of-bundle-quickview]').addEventListener('click',bundle_product.openClose)
    document.querySelector('[data-bundle-quickview-popup] .close-btn').addEventListener('click',bundle_product.openClose)
    document.querySelector('[data-add-to-cart]').addEventListener('click',bundle_product.addTocart);
  },
  getProductDetails: function(){
    var productDetails = {};
    productDetails['subtotal'] = 0;
    productDetails['items'] = [];
    document.querySelectorAll('.is-added [bundle-quantity-selector]').forEach(function(ele){
//       productDetails['subtotal'] += parseInt(ele.dataset.updatedPrice);
      productDetails['subtotal'] = productDetails['subtotal'] + ( parseInt(ele.value) * parseInt(ele.dataset.price));
      var tmp = {};
      tmp['id'] = parseInt(ele.dataset.variantId);
      tmp['quantity'] = parseInt(ele.value);
      tmp['properties'] = {}
      tmp['properties']['isBundleProduct'] = bundle_product.mainProductJson().title;
      productDetails['items'].push(tmp)
    });
    return productDetails;
  },
  mainProductJson(){
    return JSON.parse(document.getElementById('bundle-main-product-json').innerText)
  },
  changeQty:function(event){
    if(event == undefined){return;}
    event.addEventListener('change',function(){
      var mainWrapper = this.closest('.item'),
          productPrice = this.getAttribute('data-price'),
          priceSelector = mainWrapper.querySelector('.product--price'),
          calc = parseInt(productPrice) * parseInt(this.value);
      this.setAttribute('data-updated-price',calc);
      if(this.value > 0){
        mainWrapper.classList.add('is-added');
      }else{
        mainWrapper.classList.remove('is-added');
      }
      //         priceSelector.innerText = window.Shopify.formatMoney(calc,window.money_format);
      bundle_product.updateSubtotal();
      bundle_product.updateCTAButton();
    })
  },
  addTocart:function(){
    console.log(bundle_product.getProductDetails().items)
    window.addToCart(this,'',bundle_product.getProductDetails().items,window.enable_popup);
  },
  updateCTAButton:function(){
    var selector = document.querySelector('[data-add-to-cart]'),
        getLength = document.querySelectorAll('.item.is-added').length;
    if(getLength == 0){
      selector.setAttribute('disabled','disabled');
    }else{
      selector.removeAttribute('disabled');
    }
  },
  removeItemFromBundle:function(event){
    if(event == undefined){return;}
    event.addEventListener('click',function(){
      var mainWrapper = this.closest('.item.is-added'),
          qtySelector = mainWrapper.querySelector('[bundle-quantity-selector]'),
          productPrice = qtySelector.dataset.price;
      mainWrapper.classList.remove('is-added');
      qtySelector.dataset.updatedPrice = productPrice;
      qtySelector.options.selectedIndex = 0;
      bundle_product.updateSubtotal();
      bundle_product.updateCTAButton();
    })
  },
  updateSubtotal:function(){
    document.querySelector('[data-subtotal-price]').innerText = window.Shopify.formatMoney(bundle_product.getProductDetails().subtotal,window.money_format);
    document.querySelector('[data-subtotal-price-mobile]').innerText = `| ${window.Shopify.formatMoney(bundle_product.getProductDetails().subtotal,window.money_format)}`;
  },
  openModel:function(){
    document.querySelector(".custom-model-main[data-bundle-quickview-popup]").classList.add("model-open");
  },
  openClose:function(){
    document.querySelector(".custom-model-main[data-bundle-quickview-popup]").classList.remove("model-open");
  },
  quickView:function(event){
    if(event == undefined){return;}
    event.addEventListener("click",function(e){
      e.preventDefault();
      if(window.enableBundleQuickView == false){
        return;
      }
      var productUrl = this.dataset.productUrl+"?view=bundle_quickview";
      // document.querySelector('[loading-for-quickview]').style.display = 'block';
      fetch(productUrl)
      .then(resp => {
        return resp.text();
      })
      .then(responce => {
        // document.querySelector('[loading-for-quickview]').style.display = 'none';
        var parser = new DOMParser();
        var Html = parser.parseFromString(responce,'text/html'),
            productHtml = Html.querySelector("[data-bundle-quickview-wrapper]");

        document.querySelector('[data-bundle-quickView-popup] .cart-popup-content').innerHTML =  `<div class="main-product-sec spaced-section">${productHtml.innerHTML}</div>`;

        var mainImage = document.querySelector('[data-bundle-quickView-popup] .product_popup_img_main');
        let ThumbImage = document.querySelector('[data-bundle-quickView-popup] .product_popup_img_thumb');
        let enableArrow = false;
        bundle_product.openModel();
        let mainSlider = new Flickity( mainImage,{
          // options
          contain: true,
          adaptiveHeight: true,
          wrapAround: true,
          pageDots: false,
          prevNextButtons: false,
          asNavFor: '.product_popup_img_thumb',
        });
        if(ThumbImage.querySelectorAll('.image-wrapper').length > 2){
          let thumbSlider = new Flickity( ThumbImage,{
            // options
            contain: true,  
            pageDots: false,
            adaptiveHeight: true,
            prevNextButtons: true,
            cellAlign: 'left',
            wrapAround: true,
            draggable:true
          });
          thumbSlider.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
            mainSlider.select( cellIndex, false,false );
          });
          mainSlider.on( 'change', function( event ) {
            thumbSlider.select( event, false,false );
          });
        }else{
          document.querySelectorAll('[data-bundle-quickView-popup] [data-thumb-event]').forEach(function(ele){
            ele.addEventListener('click',function(e){
              var index = this.dataset.thumbEvent;
              mainSlider.select( index, false,false );
            })
          })
        }

        
      })
      .catch(function (err) {
        // There was an error
        console.warn('Something went wrong.', err);
      });
    })
  }

}

bundle_product.init();